import { createAction, props } from '@ngrx/store';

export const setTitle = createAction(
  '[App] set title',
  props<{ title: string }>()
);
